export default {"src":"/pro/_next/static/media/sonic.f31b4b13.svg","height":80,"width":82,"blurWidth":0,"blurHeight":0};